// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"162":"4ce98b80bdb5d1b8edad","189":"d586b7868d2e5b7f1262","404":"a82cde92ee9c8efdfddc","406":"ee0b6ebe4016be27c497"}[chunkId] + ".css";
};